import { render, staticRenderFns } from "./CorpsFilter.vue?vue&type=template&id=272b2001&scoped=true"
import script from "./CorpsFilter.vue?vue&type=script&lang=ts"
export * from "./CorpsFilter.vue?vue&type=script&lang=ts"
import style0 from "./CorpsFilter.vue?vue&type=style&index=0&id=272b2001&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272b2001",
  null
  
)

export default component.exports